// extracted by mini-css-extract-plugin
module.exports = {"SignInPopUp":"SignInPopUp_SignInPopUp__1mC7X","ResendEmailButtonContainer":"SignInPopUp_ResendEmailButtonContainer__2DBUI"};